// One entry per dropped file: { id, name, fileKey, parentId, status, percent }.
// status is one of QUEUED_UPLOAD_STATUS; cancelled files are removed.
const initialState = {
  items: [],
  isMinimized: false,
};

export default initialState;
